'use strict';

function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

module.exports = memoize;
//# sourceMappingURL=memoize.cjs.map
